import http from '../httpService';

export function getAllRevisionTypes() {
  return http.get(`/revision-types`);
}
export async function getAllRevisionTypesAtRevisionScopes(page = 0, result = []) {
  const { data } = await http.get(
    `/revision-types?page=${page}&size=20`
  );

  result.push(...data);

  return data?.length < 20
    ? { data: result }
    : getAllRevisionTypesAtRevisionScopes(page + 1, result);
}
export function updateRevisionTypes(payload) {
  return http.put('/revision-types', payload);
}

export function createRevisionTypes(payload) {
  return http.post('/revision-types', payload);
}

export function deleteRevisionTypes(id) {
  return http.delete(`/revision-types/${id}`);
}